import i18n from '../../i18n';
import { normalizeRichTextLink } from './richTextLink';

const Clipboard = Quill.import('modules/clipboard');
const Delta = Quill.import('delta');

class PlainTextClipboard extends Clipboard {
  onPaste(e) {
    if (e.defaultPrevented || !this.quill.isEnabled()) return;
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain').replace(/\r\n?/g, '\n');
    if (!text) return;
    const range = this.quill.getSelection(true);
    this.quill.updateContents(new Delta().retain(range.index).delete(range.length).insert(text), Quill.sources.USER);
    this.quill.setSelection(range.index + text.length, Quill.sources.SILENT);
  }
}

Quill.register('modules/clipboard', PlainTextClipboard, true);

export default [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ 'color': [] }, { 'background': [] }],  
  [{ list: "ordered" }, { list: "bullet" }],
  ['link'],
  ['clean']
];

export function configureQuillLinks(editor) {
  const button = editor.getModule('toolbar').container.querySelector('.ql-link');
  button.setAttribute('aria-label', i18n.t('richTextEditor.insertLink'));
  button.setAttribute('title', i18n.t('richTextEditor.insertLink'));
  // Guard Snow's Save path so both new links and the existing-link Edit action
  // use the same validation, including saving with Enter.
  const tooltip = editor.theme.tooltip;
  const save = tooltip.save;
  tooltip.save = function() {
    if (this.root.getAttribute('data-mode') === 'link') {
      const link = normalizeRichTextLink(this.textbox.value);
      if (!link) {
        window.alert(i18n.t('richTextEditor.invalidLink'));
        this.textbox.focus();
        return;
      }
      this.textbox.value = link;
    }
    return save.call(this);
  };
}
